export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"}],"style":[],"script":[{"src":"https://www.googletagmanager.com/gtag/js?id=G-Y1TSSVQBZ7","async":true},{"children":"\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n            gtag('config', 'G-Y1TSSVQBZ7');\n          ","type":"text/javascript"},{"type":"text/javascript","innerHTML":"\n      // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/d4wdusda'\n      (function(){var w=window;var ic=w.Intercom;if(typeof ic===\"function\"){ic('reattach_activator');\n      ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];\n      i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');\n      s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/d4wdusda';\n      var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};\n      if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();"},{"innerHTML":"(function (w, d, f) {\n      w.Produktly=w.Produktly||new Proxy(()=>{},{get:function(_,n){return(...a)=>{w.ProduktlyQ=(w.ProduktlyQ||[]).concat([[n,a]])}},apply:function(_,__,a){w.ProduktlyQ=(w.ProduktlyQ||[]).concat([[\"apply\",a]])}})\n      var a = d.getElementsByTagName('head')[0];\n      var s = d.createElement('script');\n      s.async = 1;\n      s.src = f;\n      s.setAttribute('id', 'produktlyScript');\n      s.dataset.clientToken = \"328971ef8b727111acd96d2847625ac0d2f1903813f6cfc78158e885884096225c0752732d5ecf76a393b4a26b3e834027663354662107554a60307db9ec17c3\";\n      a.appendChild(s);\n    })(window, document, \"https://public.produktly.com/js/main.js\")","type":"text/javascript"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'